import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/employees', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/employees', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/v1/employees/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/employees/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/employees/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const photoUpload = data => {
  return httpClient
    .post('/api/v1/employees/photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const position = (options = {}) => {
  return httpClient
    .get('/api/v1/employees/logic-positions', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const status = (options = {}) => {
  return httpClient
    .get('/api/v1/employees/status', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const statusReason = (options = {}) => {
  return httpClient
    .get('/api/v1/employees/status-reason', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const shift = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/shifts', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const lineManager = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/line-managers', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const pcDate = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/pc-date', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const paymentType = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/payment-types', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nationality = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/nationalities', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = attributes => {
  return httpClient
    .post('/api/v1/employees/excel/export', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const province = (Options = {}) => {
  return httpClient
    .get('/api/v1/employees/provinces', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const district = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/v1/employees/${province_code}/districts`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const commune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/v1/employees/${district_code}/communes`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const village = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/v1/employees/${commune_code}/villages`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const storeContract = data => {
  return httpClient
    .post('/api/v1/employees/store-contracts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const level = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/levels', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const addVillage = (Option = {}) => {
  return httpClient
    .post('/api/v1/employees/add-villages', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const previewPdf = data => {
  return httpClient
    .get('/api/v1/employees/preview-pdf', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const uploadfile = data => {
  return httpClient
    .post('/api/v1/employees/attachement-files', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const updateContract = (id, data) => {
  return httpClient
    .put(`/api/employees/rental-contracts/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  photoUpload,
  position,
  status,
  statusReason,
  shift,
  pcDate,
  paymentType,
  nationality,
  exportExcel,
  province,
  district,
  commune,
  village,
  storeContract,
  level,
  addVillage,
  previewPdf,
  uploadfile,
  updateContract,
  lineManager
}
